import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { Impressum } from './pages/Impressum';
import { Datenschutz } from './pages/Datenschutz';
import { LanguageProvider } from './lib/i18n';
export function App() {
  return <LanguageProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<LandingPage data-id="element-4" />} data-id="element-3" />
          <Route path="/impressum" element={<Impressum data-id="element-6" />} data-id="element-5" />
          <Route path="/datenschutz" element={<Datenschutz data-id="element-8" />} data-id="element-7" />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>;
}